module.exports = __webpack_public_path__ + "img/Apple-App-Store.bcd50f79.jpg";